function getColorBrightness(rgbColor) {
  var colorValues = rgbColor.match(/[\d\.]+/g).map(Number);
  return 0.2126 * (colorValues[0] / 255) + 0.7152 * (colorValues[1] / 255) + 0.0722 * (colorValues[2] / 255);
}

function isSimilarToBackground(color) {
  var backgroundColor = 'rgb(255, 255, 255)';

  var colorBrightness = getColorBrightness(color);
  var backgroundColorBrightness = getColorBrightness(backgroundColor);

  return (backgroundColorBrightness / colorBrightness) < 1.5;
}

var SwatchColors = (function() {
  function SwatchColors() {
    this.colors = {'army-green': 'rgb(75, 83, 32)','navy-blue': 'rgb(0, 0, 128)','twill-gray': 'rgb(139, 140, 141)','twill-green': 'rgb(85, 107, 47)','twill-brown': 'rgb(123, 79, 53)','amethyst': 'rgb(153, 102, 204)','garnet': 'rgb(154, 42, 42)','peridot': 'rgb(180, 196, 36)','topaz': 'rgb(250, 234, 115)','citrine': 'rgb(228, 208, 10)','emerald': 'rgb(4, 99, 7)','tanzanite': 'rgb(59, 75, 127)','blue-topaz': 'rgb(66, 111, 126)','sapphire': 'rgb(1, 49, 180)','ruby': 'rgb(224, 17, 95)','moonstone': 'rgb(231, 235, 247)','tsavorite': 'rgb(1, 150, 3)','almandine-garnet': 'rgb(122, 16, 30)','african-amethyst': 'rgb(141, 44, 183)','aquamarine': 'rgb(169, 221, 232)','green-tourmaline': 'rgb(145, 179, 60)',};

    this.images = {};

    this.triggers = ['color','colour','couleur','farbe','cor',];
  }

  function setSwatchColor(swatch) {
    var swatchId = swatch.getAttribute('swatch-id');

    if (Object.keys(this.colors).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.colors[swatchId]);

      if (isSimilarToBackground(this.colors[swatchId])) swatch.classList.add('is-similar-to-background');
      if (getColorBrightness(this.colors[swatchId]) > 0.5) {
        swatch.style.setProperty('--tick-color', '#000');
      } else {
        swatch.style.setProperty('--tick-color', '#fff');
      }
      swatch.classList.remove('is-blank');
    }

    if (Object.keys(this.images).includes(swatchId)) {
      swatch.style.setProperty("--background-graphic", this.images[swatchId]);
      swatch.classList.add('is-image');
      swatch.classList.remove('is-blank');
    }
  }
  SwatchColors.prototype.setSwatchColor = setSwatchColor;

  return SwatchColors;
}());

const Swatches = new SwatchColors();

function VariantSwatch() {
  return Reflect.construct(HTMLElement, [], this.constructor);
}

VariantSwatch.prototype = Object.create(HTMLElement.prototype);
VariantSwatch.prototype.constructor = VariantSwatch;
Object.setPrototypeOf(VariantSwatch, HTMLElement);

VariantSwatch.prototype.connectedCallback = function() {
  Swatches.setSwatchColor(this);
};
customElements.define('variant-swatch', VariantSwatch);

export default Swatches;
